function toggleMenu() {
  const menuDrawer = document.getElementById('menu-drawer');
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  // Always close cart first (force close to prevent both being open)
  if (cartDrawer) {
    cartDrawer.classList.add('translate-x-full');
  }

  // Toggle menu
  const isMenuOpen = !menuDrawer.classList.contains('-translate-x-full');

  if (isMenuOpen) {
    // Close menu
    menuDrawer.classList.add('-translate-x-full');
    overlay.classList.add('hidden');
  } else {
    // Open menu
    menuDrawer.classList.remove('-translate-x-full');
    overlay.classList.remove('hidden');
  }
}

function toggleCart() {
  const cartDrawer = document.getElementById('cart-drawer');
  const menuDrawer = document.getElementById('menu-drawer');
  const overlay = document.getElementById('overlay');

  // Always close menu first (force close to prevent both being open)
  if (menuDrawer) {
    menuDrawer.classList.add('-translate-x-full');
  }

  // Toggle cart
  const isCartOpen = !cartDrawer.classList.contains('translate-x-full');

  if (isCartOpen) {
    // Close cart
    cartDrawer.classList.add('translate-x-full');
    overlay.classList.add('hidden');
  } else {
    // Open cart
    cartDrawer.classList.remove('translate-x-full');
    overlay.classList.remove('hidden');
  }
}

function closeAllDrawers() {
  const menuDrawer = document.getElementById('menu-drawer');
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  if (menuDrawer) menuDrawer.classList.add('-translate-x-full');
  if (cartDrawer) cartDrawer.classList.add('translate-x-full');
  if (overlay) overlay.classList.add('hidden');
}

// Global helper to save preference when buttons are clicked (called from inline onclick)
window.saveLanguagePreference = function (isoCode) {
  localStorage.setItem('sindrome_user_lang', isoCode);
}

function toggleAccordion(id) {
  const el = document.getElementById(id);
  if (!el) return;

  // Toggle Tailwind classes for accordion effect
  // We use classList checks to swap simple state
  if (el.classList.contains('max-h-0')) {
    el.classList.remove('max-h-0', 'opacity-0');
    el.classList.add('max-h-96', 'opacity-100');
  } else {
    el.classList.add('max-h-0', 'opacity-0');
    el.classList.remove('max-h-96', 'opacity-100');
  }
}

async function updateCartQuantity(line, quantity) {
  const notification = document.getElementById('cart-notification');
  const notificationMain = document.getElementById('cart-notification-main');

  if (notification) notification.classList.add('hidden');
  if (notificationMain) notificationMain.classList.add('hidden');

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    });

    const data = await response.json();

    if (response.ok) {
      // Seamlessly refresh cart drawer contents
      await refreshCartDrawer();
    } else {
      // Handle 422 Unprocessable Entity (Stock limit)
      let errorMsg = data.description || data.message || "Errore durante l'aggiornamento del carrello.";

      // If it's a stock limit, make it more user-friendly
      if (response.status === 422) {
        errorMsg = "Quantità massima disponibile raggiunta.";
      }

      if (notification) {
        notification.textContent = errorMsg;
        notification.classList.remove('hidden');
        setTimeout(() => notification.classList.add('hidden'), 5000);
      }
      if (notificationMain) {
        notificationMain.textContent = errorMsg;
        notificationMain.classList.remove('hidden');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  } catch (error) {
    console.error('Error updating cart:', error);
    const connectionError = "Errore di connessione. Riprova.";
    if (notification) {
      notification.textContent = connectionError;
      notification.classList.remove('hidden');
    }
    if (notificationMain) {
      notificationMain.textContent = connectionError;
      notificationMain.classList.remove('hidden');
    }
  }
}

async function refreshCartDrawer() {
  try {
    const response = await fetch(window.location.href);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Update cart items
    const newItems = doc.getElementById('cart-items');
    const currentItems = document.getElementById('cart-items');
    if (newItems && currentItems) {
      currentItems.innerHTML = newItems.innerHTML;
    }

    // Update cart total
    const newTotal = doc.getElementById('cart-total');
    const currentTotal = document.getElementById('cart-total');
    if (newTotal && currentTotal) {
      currentTotal.innerHTML = newTotal.innerHTML;
    }

    // Update header cart count if present
    const newCount = doc.getElementById('cart-count');
    const currentCount = document.getElementById('cart-count');
    if (newCount && currentCount) {
      currentCount.innerHTML = newCount.innerHTML;
    }

    // Notify other components (like the product page) that the cart has changed
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

    // Update main cart page root if present
    const newMain = doc.getElementById('main-cart-root');
    const currentMain = document.getElementById('main-cart-root');
    if (newMain && currentMain) {
      currentMain.innerHTML = newMain.innerHTML;
    }

  } catch (error) {
    console.error('Error refreshing cart drawer:', error);
  }
}

// Product form AJAX handling
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.action.includes('/cart/add')) return;

  e.preventDefault();

  const submitButton = form.querySelector('[type="submit"]');
  const errorArea = form.querySelector('[id^="product-error-"]');

  if (errorArea) errorArea.classList.add('hidden');
  if (submitButton) submitButton.disabled = true;

  try {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantityToAdd = parseInt(formData.get('quantity') || '1');

    // --- PRE-CHECK AVAILABILITY ---
    const variantsDataEl = document.getElementById('ProductVariantsJson');
    if (variantsDataEl) {
      try {
        const variants = JSON.parse(variantsDataEl.textContent);
        const selectedVariant = variants.find((v) => v.id.toString() === variantId);

        if (
          selectedVariant &&
          selectedVariant.inventory_management === 'shopify' &&
          selectedVariant.inventory_policy === 'deny'
        ) {
          // Fetch current cart to check existing quantity of this variant
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          const existingItem = (cart.items || []).find(
            (item) => item.variant_id && item.variant_id.toString() === variantId
          );
          const existingQuantity = existingItem ? existingItem.quantity : 0;
          const totalAfterAddition = existingQuantity + quantityToAdd;

          if (totalAfterAddition > selectedVariant.inventory_quantity) {
            if (errorArea) {
              const remaining = selectedVariant.inventory_quantity - existingQuantity;
              if (remaining <= 0) {
                errorArea.textContent = 'Hai già aggiunto tutti i pezzi disponibili al carrello.';
              } else {
                errorArea.textContent = `Puoi aggiungere solo altri ${remaining} pezzi (ne hai già ${existingQuantity} nel carrello).`;
              }
              errorArea.classList.remove('hidden');
            }
            if (submitButton) submitButton.disabled = false;
            return; // Block addition
          }
        }
      } catch (jsonErr) {
        console.warn('Error during pre-check:', jsonErr);
        // Fallback: allow the addition if pre-check logic fails
      }
    }
    // --- END PRE-CHECK ---

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    });

    const data = await response.json();

    if (response.ok) {
      await refreshCartDrawer();
      toggleCart();
    } else {
      if (errorArea) {
        errorArea.textContent = data.description || data.message || "Errore durante l'aggiunta al carrello.";
        errorArea.classList.remove('hidden');
      }
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    if (errorArea) {
      errorArea.textContent = "Errore di connessione. Riprova.";
      errorArea.classList.remove('hidden');
    }
  } finally {
    if (submitButton) submitButton.disabled = false;
  }
});

// Re-open cart if URL parameter is present (fallback for direct links/manual reloads)
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('cart_open') === 'true') {
    toggleCart();
    // Clean up URL without reloading
    const newUrl = window.location.pathname + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }
});
